import { createNestedMapping } from "helpers";
import { MaterialChemistry } from "store/api/generatedApi";

export const restoreChemistryMeasurements = ({
  overrides,
  defaults,
  materialIds,
  elementIds,
}: {
  overrides: MaterialChemistry[];
  defaults: MaterialChemistry[];
  materialIds: Set<number>;
  elementIds: Set<number>;
}): MaterialChemistry[] => {
  const restored = defaults.filter(
    (measurement) =>
      materialIds.has(measurement.material_id) &&
      elementIds.has(measurement.chemical_element_id)
  );
  const restoredByPair = createNestedMapping(
    restored,
    (measurement) => measurement.material_id,
    (measurement) => measurement.chemical_element_id
  );
  return [
    ...overrides.filter(
      (measurement) =>
        !restoredByPair[measurement.material_id]?.[
          measurement.chemical_element_id
        ]
    ),
    ...restored,
  ];
};
